// Options are advertised and validated by the backend provider contract.
export function normalizeMediaSettings(caps, saved = {}) {
  if (!caps) return null;
  const result = {};
  for (const [field, values] of Object.entries({
    duration: caps.durations,
    size: caps.sizes,
    quality: caps.qualities,
    resolution: caps.resolutions,
    ratio: caps.ratios,
  })) {
    if (values?.length)
      result[field] = values.includes(saved[field]) ? saved[field] : values[0];
  }
  if (caps.stream && saved.mode === 'stream') result.mode = 'stream';
  return result;
}
